import React from "react";
import { MdPlayArrow } from "react-icons/md";

import "../../css/fabButton.css";

const FAB = ({ actions }) => {
  return ( 
    <ul
      className="fab-container"
    >
      <li className="fab-button fabLi" style={{background: '#fff'}}>
        <MdPlayArrow style={{opacity: "1", color: "#3B82F6"}}/>
      </li>
    </ul>
  );
};

export default FAB;